import { useState } from "react";

let Counter = () => {
  let [count, setCount] = useState(0);

  let handleCounting = () => {
    if (count === 10) {
      setCount(0);
    } else {
      setCount(count + 1);
    }
  };

  return (
    <div>
      <h2>This is a counter</h2>
      <span>{count} </span>
      <button onClick={handleCounting}>Count</button>
    </div>
  );
};

export default Counter;
